.card:hover .description {
  max-height: 3lh;
  opacity: 1;
  margin-top: var(--mantine-spacing-xxxs);
}

.description {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition:
    max-height 250ms ease,
    opacity 200ms ease,
    margin-top 250ms ease;
}
